import React, { Fragment, useState } from 'react';
import { createPortal } from 'react-dom';
import style from './descModal.css';

/* 疫情说明的弹窗 */
const DescModal = function DescModal(props) {
    const [visible, setVisible] = useState(false);

    const modalRender = function modalRender(props) {
        return createPortal(
            <div className={style.modalMark}>
                <div className={style.modalContent}>
                    <button
                        className={style.close}
                        type="button"
                        aria-label="关闭"
                        onClick={event => setVisible(false)}
                    />
                    <h2 className={style.title}>全球新冠疫苗接种数据说明</h2>
                    <p className={style.text}>1、中国疫苗接种数据来自国家卫健委发布；</p>
                    <p className={style.text}>2、数据单位为剂，而非接种人数。</p>
                </div>
            </div>,
            document.body,
        );
    };

    return (
        <Fragment>
            <button className={style.descBtn} type="button" onClick={event => setVisible(true)} />
            {visible ? modalRender() : null}
        </Fragment>
    );
};

export default DescModal;
